import { mediaItems } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading text-center mb-3">
          热门视频
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          精选网红爆料解说视频，深度还原事件真相
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200 rounded-xl overflow-hidden cursor-pointer hover:border-primary-300 transition-all"
            >
              <div className="relative aspect-video bg-background-200 overflow-hidden">
                <img
                  src={item.thumbnail}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 right-2 bg-background-950/80 text-background-50 text-xs px-2 py-0.5 rounded font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90">
                    <i className="ri-play-fill text-xl text-background-50 ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.views}次观看</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-800 leading-snug line-clamp-2">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}